import { EDITOR_ID, Emoticon } from '~/constants';
import { emoticonStickerStore } from '~/stores/EmoticonStickerStore';
import { action, observable } from 'mobx';

class EmoticonPopperState {
  public readonly editorId: EDITOR_ID;

  @observable
  public isOpen = false;

  @observable
  public tab: Emoticon;

  public tabs: Emoticon[];

  constructor({
    editorId,
    isOpen,
    tab,
    tabs,
  }: {
    editorId: EDITOR_ID;
    isOpen: boolean;
    tab: Emoticon;
    tabs: Emoticon[];
  }) {
    this.editorId = editorId;
    this.isOpen = isOpen;
    this.tab = tab;
    this.tabs = tabs;
  }

  @action
  public setOpen = (isOpen: boolean) => {
    this.isOpen = isOpen;
  };

  @action
  public setTab = (tab: Emoticon) => {
    this.tab = tab;
    emoticonStickerStore.reset(tab);
  };
}

export default EmoticonPopperState;
